export default __webpack_public_path__ + "static/media/pic1.51cc8e86.jpg";